.time-selector-container {
  display: flex;
  background-color: var(--color-gray-8);
  align-items: center;
  justify-content: center;
}

.time-input-container {
  width: 4.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:last-of-type {
    margin-left: 1.6rem;
  }
}

.time-input {
  width: 100%;
  outline: none;
  border: none;
  border-bottom: 1.5px solid var(--color-grey-5);
  font-size: 3.2rem;
  line-height: 3.873rem;
  text-align: center;
  font-weight: 700;
  color: #f2f3f5;
  background-color: transparent;
}

.down-arrow-container {
  margin-top: 1.7rem;
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: var(--color-secondary);

    & > svg {
      stroke: white;
    }
  }
  & > svg {
    stroke: #367bff;
  }
}

.up-arrow-container {
  margin-bottom: 1.7rem;
  transform: rotate(180deg);
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: var(--color-secondary);

    & > svg {
      stroke: white;
    }
  }
  & > svg {
    stroke: #367bff;
  }
}

.time-letters {
  font-size: 3.2rem;
  font-weight: 500;
  line-height: 3.873rem;
  text-align: center;
  color: var(--color-grey-4);
  margin-left: 0.4rem;
}

.dialog-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
